import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username } from '../internal.js'

const credentialTypes = [username, password, 'key'] as const
const locationCredentialTypes = ['customer-code'] as const

export type oakhCredType =
  | (typeof credentialTypes)[number]
  | (typeof locationCredentialTypes)[number]

export const oakhDocumentTypes = [
  'proof-of-delivery',
  'signed-bol',
  'weights-and-corrections',
] as const satisfies readonly DocumentType[]

export const oakh: CarrierDef<oakhCredType> = {
  name: 'Oak Harbor Freight Lines',
  scac: 'oakh',
  ltlServices: [
    { id: 'standard', name: 'Standard' },
    {
      id: 'guaranteed_five_pm',
      name: 'Guaranteed',
      guaranteed: true,
      guaranteedByTime: '17:00',
    },
    {
      id: 'guaranteed_twelve_pm',
      name: 'Guaranteed by Noon',
      guaranteed: true,
      guaranteedByTime: '12:00',
    },
  ],
  credentialTypes,
  locationCredentialTypes,
  legacyCredMap: [
    ['username', 'username'],
    ['key', 'apiKey'], // engine only
    ['key', 'password'], // engine only and apikey is set on the only entry - why have this?
    ['customer-code', 'ref1'],
  ],
  engineLayers: ['rating', 'bol', 'pickup', 'documents', 'tracking'],
  documentTypes: oakhDocumentTypes,
  credentialConfig: {
    'customer-code': { customerIdentifier: true },
  },
}
